/** Das Kontrollzentrum (`/control-center`): die Verwaltung des Servers selbst. */

export default {
	controlCenter: {
		nav: {
			exit: "Zurück zu Notitia",
			users: "Benutzer",
			roles: "Systemrollen",
			departments: "Abteilungen",
			projects: "Projekte",
			dataspaces: "Dataspaces",
			releases: "Releases",
			"service-tokens": "Service-Token",
			runtime: "Laufzeit",
			maintenance: "Wartung",
			settings: "Einstellungen",
			license: "Lizenz",
			groups: {
				people: "Personen",
				content: "Inhalte",
				server: "Server",
			},
		},
		users: {
			search: "Benutzer suchen…",
			empty: "Kein Benutzer gefunden.",
			roleFor: "Systemrolle von {name}",
			changed: "{name} ist jetzt {role}.",
			column: {
				user: "Benutzer",
				systemRole: "Systemrolle",
				projects: "Projekte",
				dataspaces: "Dataspaces",
				joined: "Registriert",
			},
			banConfirm: "{name} sperren?",
			banNote:
				"Die Person wird sofort überall abgemeldet und kann sich erst wieder anmelden, wenn sie eine andere Rolle bekommt. Die Mitgliedschaften der Person bleiben bestehen.",
			ban: "Sperren",
			adminConfirm: "{name} zum Serveradmin machen?",
			adminNote:
				"Serveradmins haben jede Systemberechtigung und können die Rolle jedes Benutzers, jede Systemrolle sowie jedes Projekt und jeden Dataspace ändern.",
			makeAdmin: "Zum Serveradmin machen",
		},
		roles: {
			names: {
				user: "Benutzer",
				server_admin: "Serveradmin",
				banned: "Gesperrt",
			},
			sections: {
				access: "Zugang",
				controlCenter: "Kontrollzentrum",
			},
			ops: {
				signin: "Anmelden",
				inviteUsers: "Benutzer einladen",
				mintPermanentPats: "Persönliche Zugriffstoken ohne Ablaufdatum erstellen",
				manageUsers: "Benutzer verwalten",
				manageRoles: "Systemrollen verwalten",
				manageProjects: "Alle Projekte verwalten",
				manageDataspaces: "Alle Dataspaces verwalten",
				manageReleases: "Alle Releases verwalten: exportieren und importieren",
				manageServiceTokens: "Service-Token für den Server erstellen",
				manageServer: "Den Server betreiben: Laufzeit, Wartung, Einstellungen und Lizenz",
				createDepartments: "Abteilungen durch Eingabe eines Lizenzschlüssels erstellen",
				aliasDataspaces: "Dataspaces mit einem Alias in den URLs des Operators benennen",
				manageDepartments:
					"Alle Abteilungen verwalten: Lizenzschlüssel, Eigentümer und Löschung",
			},
			userCount: "Keine Benutzer | {n} Benutzer | {n} Benutzer",
			locked: "Fest",
			noRename:
				"Eine Systemrolle wird nie umbenannt, denn Benutzer sind ihr über den Namen zugeordnet. Duplizieren Sie sie, um eine neue anzulegen.",
			deleteNote:
				"Keinem Benutzer ist diese Rolle zugewiesen. Das lässt sich nicht rückgängig machen.",
		},
		members: {
			add: "Mitglied hinzufügen",
			addMe: "Mich hinzufügen",
			addTitle: "Mitglied hinzufügen",
			user: "Benutzer",
			userPlaceholder: "Nach Name oder E-Mail suchen…",
			added: "{name} hinzugefügt.",
			addedSelf: "Sie sind jetzt Mitglied.",
			roleChanged: "Rolle von {name} geändert.",
			remove: "{name} entfernen",
			removed: "{name} entfernt.",
			removeConfirm: "{name} entfernen?",
			removeSelfConfirm: "Sich selbst entfernen?",
			removeNote:
				"Der Zugang endet sofort, und offene Sitzungen erhalten keine Änderungen mehr.",
		},
		projects: {
			filesMissing: "Dateien fehlen",
			filesMissingTitle: "Die Dateien dieses Projekts fehlen auf dem Server",
			filesMissingNote:
				"Nur sein Datensatz ist übrig, deshalb lässt sich nichts darin öffnen. Sie können es in der Wartung endgültig entfernen.",
			filesMissingAskNote:
				"Nur sein Datensatz ist übrig, deshalb lässt sich nichts darin öffnen. Ein Serveradmin kann es in der Wartung endgültig entfernen.",
			search: "Projekte suchen…",
			empty: "Kein Projekt gefunden.",
			createdBy: "Erstellt von {name}",
			notMember: "Kein Mitglied",
			notMemberHint:
				"Sie sind kein Mitglied dieses Projekts. Fügen Sie sich hinzu, um es im Designer zu öffnen.",
			openDesigner: "Im Designer öffnen",
			noDataspaces: "Kein Dataspace führt dieses Projekt aus.",
			deleted: "{name} gelöscht.",
			deleteConfirm: "{name} löschen?",
			deleteNote:
				"Alle Mitglieder verlieren es, und Projekte, die davon abhängen, können es nicht mehr auflösen. Seine Dataspaces führen ihre vorhandenen Builds weiter aus.",
			column: {
				project: "Projekt",
				department: "Abteilung",
				version: "Version",
				members: "Mitglieder",
				yourRole: "Ihre Rolle",
				updated: "Geändert",
			},
		},
		dataspaces: {
			search: "Dataspaces suchen…",
			empty: "Kein Dataspace gefunden.",
			notMemberHint:
				"Sie sind kein Mitglied dieses Dataspace. Fügen Sie sich hinzu, um ihn im Operator zu öffnen.",
			openOperator: "Im Operator öffnen",
			noProcesses: "Hier wurde noch nichts gestartet.",
			deleted: "{name} gelöscht.",
			deleteConfirm: "{name} löschen?",
			deleteNote:
				"Laufende Prozesse werden zuerst gestoppt. Mitglieder, Rollen, Umgebung und Prozessverlauf gehen verloren. Das lässt sich nicht rückgängig machen.",
			column: {
				dataspace: "Dataspace",
				running: "Laufend",
			},
		},
		departments: {
			search: "Abteilungen suchen…",
			empty: "Keine Abteilung gefunden.",
			create: "Abteilung erstellen",
			column: {
				department: "Abteilung",
				license: "Lizenz",
				members: "Mitglieder",
				projects: "Projekte",
				dataspaces: "Dataspaces",
				owners: "Eigentümer",
			},
			createNote:
				"Der Lizenzschlüssel wird zuerst beim Lizenzserver geprüft. Sie werden nicht Mitglied: Eigentümer wird die Person, die Sie per E-Mail nennen.",
			ownerEmail: "E-Mail des Eigentümers",
			ownerEmailHelp:
				"Die Person bekommt eine Einladung, Eigentümer der Abteilung zu werden; bis sie annimmt, hat die Abteilung keinen Eigentümer.",
			created: "{name} erstellt.",
			createdInvited: "{name} erstellt. {email} wurde eingeladen, Eigentümer zu werden.",
			rekeyTitle: "Lizenzschlüssel von {name} ersetzen",
			rekeyed: "Lizenzschlüssel von {name} ersetzt.",
			ownersTitle: "Eigentümer von {name}",
			ownersNote:
				"Eigentümer haben jede Berechtigung der Abteilung. Eine Abteilung behält mindestens einen.",
			ownersNone: "Diese Abteilung hat noch keinen Eigentümer.",
			makeOwner: "Zum Eigentümer machen",
			makeOwnerHelp:
				"Ein Mitglied der Abteilung mit dieser E-Mail wird sofort Eigentümer; alle anderen erhalten eine Einladung, Eigentümer zu werden.",
			owners: {
				promoted: "{email} ist jetzt Eigentümer.",
				invited:
					"{email} wurde eingeladen, Eigentümer der Abteilung zu werden — und ist es, sobald die Einladung angenommen wird.",
				demote: "{name} zum Mitglied machen",
				demoted: "{name} ist jetzt Mitglied.",
			},
			rowMenu: {
				owners: "Eigentümer verwalten",
				rekey: "Lizenzschlüssel ersetzen",
				moveIn: "Spaces hierher verschieben…",
				moveOut: "Spaces persönlich machen…",
			},
			spaces: {
				titleIn: "Spaces nach {name} verschieben",
				titleOut: "Spaces von {name} persönlich machen",
				noteIn: "Jedes Projekt und jeder Dataspace des Servers kann hierher verschoben werden, unabhängig davon, was Sie selbst damit tun dürfen. Ein Space aus einer anderen Abteilung verlässt diese. Sein Abteilungszugriff beginnt von vorn: Die Eigentümer dieser Abteilung verwalten ihn, und niemand sonst erreicht ihn über die Abteilung, bis Rollen zugeordnet werden. Es wird nur etwas verschoben, wenn alles verschoben werden kann.",
				noteOut:
					"Die Spaces behalten die von Hand hinzugefügten Personen und verlieren die der Abteilung. Ein Space ohne eigenen Admin lässt sich von hier nicht persönlich machen, weil das Kontrollzentrum keine eigene Rolle zu vergeben hat: Fügen Sie zuerst auf der Seite des Projekts oder des Dataspace einen Admin hinzu. Es wird nur etwas verschoben, wenn alles verschoben werden kann.",
				noneIn: "Alles auf dem Server liegt schon in dieser Abteilung.",
				noneOut: "In dieser Abteilung liegt nichts.",
				confirmIn: "{n} Space verschieben | {n} Spaces verschieben",
				confirmOut: "{n} Space persönlich machen | {n} Spaces persönlich machen",
				movedIn: "{n} Space nach {name} verschoben. | {n} Spaces nach {name} verschoben.",
				movedOut:
					"{n} Space von {name} ist jetzt persönlich. | {n} Spaces von {name} sind jetzt persönlich.",
			},
			default: {
				title: "Standardabteilung",
				note: "Jeder Benutzer mit einem Konto ist Mitglied der Standardabteilung und hat dort die hier gewählte Rolle, sofern er keine eigene Mitgliedschaft hat. Was diese Rolle erlaubt, gilt also für den ganzen Server, auch in den Spaces der Abteilung. Die Live-Aktualisierungen der Spaces folgen dem neuen Zugriff sofort, aber niemand wird einzeln benachrichtigt: Eine geöffnete Sitzung erfährt davon erst beim nächsten Seitenwechsel.",
				department: "Abteilung",
				role: "Rolle aller Benutzer",
				roleHelp: "Wählen Sie mit Bedacht: Alle Benutzer haben sie.",
				none: "Keine",
				saved: "{name} ist jetzt die Standardabteilung.",
				cleared: "Es gibt jetzt keine Standardabteilung.",
			},
			deleted: "{name} gelöscht.",
			deleteConfirm: "{name} löschen?",
			deleteNote:
				"Mitglieder und Rollen der Abteilung gehen mit ihr verloren. Das lässt sich nicht rückgängig machen. Eine Abteilung mit einem Projekt oder Dataspace und die Standardabteilung lassen sich nicht löschen.",
		},
		releases: {
			search: "Releases suchen…",
			empty: "Kein Release gefunden.",
			none: "Auf diesem Server wurde noch nichts veröffentlicht.",
			column: {
				project: "Projekt",
				version: "Version",
				origin: "Herkunft",
				created: "Veröffentlicht",
				build: "Build",
			},
			importedProject: "Importiertes Projekt",
			import: {
				action: "Release importieren",
				title: "Ein Release importieren",
				note: "Eine .notitia-release.zip, exportiert von einem anderen Notitia-Server. Sie wird geprüft, bevor etwas importiert wird.",
				choose: "Datei auswählen",
				chosen: "{name} · {size}",
				checking: "Das Archiv wird geprüft…",
				project: "Projekt",
				version: "Version",
				exportedFrom: "Exportiert von",
				exportedAt: "Exportiert",
				engine: "Engine",
				node: "Node",
				packages: "Pakete",
				sha256: "SHA-256",
				notes: "Notizen",
				outcome: {
					newProject:
						"{name} ist nicht auf diesem Server. Es wird als Projekt angelegt, das nur durch seine Releases bekannt ist, und Sie werden sein Admin.",
					newVersion:
						"{name} ist auf diesem Server. v{version} kommt zu seinen Releases hinzu.",
					identical:
						"Genau dieses Archiv wurde schon importiert. Ein erneuter Import ändert nichts.",
					conflict: "Dieses Archiv kann nicht importiert werden.",
				},
				confirm: "Importieren",
				done: "{name} v{version} importiert.",
				doneIdentical: "{name} v{version} war bereits vorhanden. Es wurde nichts geändert.",
				another: "Weiteres Release importieren",
				errors: {
					invalidArchive:
						"Diese Datei ist kein Release-Archiv, oder sie hat die Prüfung nicht bestanden.",
					conflict:
						"Dieser Server hat diese Version des Projekts bereits, aus einem anderen Archiv.",
				},
			},
			project: {
				none: "Dieses Projekt hat keine Releases.",
				runnable: "Hier ausführbar",
			},
		},
		serviceTokens: {
			description:
				"Service-Token sind Zugangsdaten dieses Servers selbst, für unbeaufsichtigt laufende Anwendungen wie CI-Jobs und Integrationen. Die Rechte eines Tokens sind genau die, die ihm hier erteilt werden — nie die des Admins, der es erstellt hat, und nie an eine Person gebunden.",
			mint: {
				action: "Token erstellen",
				title: "Service-Token erstellen",
			},
			list: {
				title: "Die Token dieses Servers",
				empty: "Noch keine Service-Token. Erstellen Sie eines, um einem CI-Job oder einer Integration Zugriff zu geben.",
				revoked: "Token widerrufen",
				revoke: {
					title: "Dieses Token widerrufen?",
					body:
						"Alles, was das Token „{name}“ verwendet, verliert sofort den Zugriff. Das lässt sich nicht rückgängig machen. " +
						"Ein daraus bereits abgeleitetes Zugriffstoken funktioniert noch bis zum Ende seiner eigenen kurzen Laufzeit.",
				},
			},
			error: {
				generic: "Bei den Service-Token ist etwas schiefgelaufen. Versuchen Sie es erneut.",
				service_token_not_found:
					"Dieses Token existiert nicht mehr. Die Liste wurde neu geladen.",
				service_token_name_invalid:
					"Dieser Name wird nicht angenommen. Verwenden Sie 1–100 Zeichen ohne unsichtbare Formatierung.",
				service_token_lifetime_exceeded:
					"Diese Laufzeit ist länger, als der Anbieter erlaubt. Wählen Sie weniger Tage.",
				service_token_grants_invalid:
					"Die Berechtigungen wurden nicht angenommen. Ein Token braucht 1 bis 100 gültige Berechtigungen.",
				service_token_grant_not_available:
					"Eine Berechtigung wurde abgelehnt: Das Projekt oder der Dataspace existiert nicht, oder die Berechtigung lässt sich dort nicht vergeben.",
				service_token_mint_refused:
					"Der Identitätsanbieter hat die Erstellung abgelehnt. Ein Token ohne Ablauf ist vielleicht nicht erlaubt — legen Sie stattdessen eine Laufzeit fest.",
				idp_unavailable:
					"Der Identitätsanbieter ist nicht erreichbar. Versuchen Sie es später erneut.",
			},
		},
		runtime: {
			server: "Server",
			version: "Version",
			uptime: "Betriebszeit",
			running: "Laufende Prozesse",
			noProcesses: "Auf diesem Server gibt es noch keinen Prozess.",
			builds: "Laufende Builds",
			cache: "Geöffnete Projekte",
			cacheNote: "{n} von höchstens {max}, jedes nach {ttl} Minuten Leerlauf geschlossen",
			cacheEmpty: "Kein Projekt ist geöffnet.",
			stale: "Wird neu geöffnet, sobald frei",
			seconds: "{n} s",
			minutes: "{n} min",
			hours: "{n} h",
			days: "{n} Tage",
			restart: "{name} neu starten",
			restarting: "{name} wird neu gestartet.",
			stop: "{name} stoppen",
			stopped: "{name} gestoppt.",
			stopConfirm: "{name} stoppen?",
			stopNote:
				"Alle, die in {dataspace} arbeiten, sehen ihn stoppen. Sein letzter Zustand wird gespeichert.",
			stopAction: "Stoppen",
			status: {
				running: "Läuft",
				starting: "Startet",
				stopped: "Gestoppt",
				failed: "Fehlgeschlagen",
				archived: "Archiviert",
			},
			column: {
				process: "Prozess",
				status: "Status",
				restartRule: "Neustartregel",
				idle: "Leerlauf",
			},
		},
		maintenance: {
			permanent:
				"Was hier entfernt wird, ist endgültig weg. Nichts auf dieser Seite lässt sich rückgängig machen.",
			size: "Größe",
			file: "Name",
			kind: "Art",
			none: "Keine",
			nothing: "Nichts aufzuräumen.",
			deleteDataspacesFirst: "Läuft noch in — zuerst löschen:",
			purgeAll: "{n} endgültig entfernen",
			purgeOne: "{name} endgültig entfernen?",
			purgeMany: "{n} Projekte endgültig entfernen?",
			purgeBrokenNote:
				"Datensätze, Mitglieder, Rollen und Einladungen sowie was von Dateien und Builds übrig ist, werden entfernt. Mitglieder sehen sie aus ihren Listen verschwinden. Ein Paket, das ein anderes Projekt verwendet, bleibt.",
			purgeDeletedNote:
				"Datensätze, Dateien und Builds werden entfernt. Ein Paket, das ein anderes Projekt verwendet, bleibt.",
			removeAll: "{n} entfernen",
			removeFileOne: "{name} entfernen?",
			removeFileMany: "{n} verwaiste Dateien entfernen?",
			removeFileNote:
				"Nichts auf dem Server verweist darauf. Sie werden von der Festplatte gelöscht.",
			removeForGood: "Endgültig entfernen",
			removed: "{n} entfernt. | {n} entfernt. | {n} entfernt.",
			skipped: "{item} nicht entfernt: {why}",
			broken: {
				title: "Defekte Projekte",
				note: "Datensätze, deren Dateien auf dem Server fehlen oder unvollständig sind",
			},
			deleted: {
				title: "Gelöschte Projekte",
				note: "In der App gelöscht, aber noch auf der Festplatte",
			},
			files: {
				title: "Verwaiste Dateien",
				note: "Verzeichnisse und Dateien, auf die kein Datensatz verweist",
			},
			expired: {
				title: "Abgelaufene Einträge",
				hint: "Aufbewahrt, nachdem sie nicht mehr funktionieren",
				invitations: "Abgelaufene Einladungen",
				confirm: "{n} abgelaufene Einträge entfernen?",
				note: "Abgelaufene Einladungen funktionieren nicht mehr.",
			},
			kinds: {
				project: "Projekt",
				build: "Build",
				package: "Paket",
				process_state: "Prozesszustand",
			},
			bytes: {
				b: "{n} B",
				kb: "{n} KB",
				mb: "{n} MB",
				gb: "{n} GB",
			},
		},
		settings: {
			saved: "Gespeichert.",
			discard: "Änderungen verwerfen",
			saveFirst: "Speichern oder verwerfen Sie Ihre Änderungen, um zu testen.",
			invalid:
				"{field} wurde nicht angenommen. Prüfen Sie den Wert und speichern Sie erneut.",
			invalidField: "Dieser Wert wurde nicht angenommen.",
			change: "{label} ändern",
			keepCurrent: "Den aktuellen behalten",
			secretKeep: "Leer lassen, um den aktuellen zu behalten.",
			secretReplaces: "Speichern ersetzt den aktuellen.",
			inherit: "Den geerbten Wert verwenden",
			keepSetHere: "Den hier gesetzten Wert behalten",
			unreadable:
				"Einige gespeicherte Geheimnisse lassen sich mit der Schlüsseldatei dieses Servers (data/secret.key) nicht entschlüsseln und werden ignoriert, bis sie neu eingegeben werden:",
			source: {
				env: "Aus der Umgebung des Servers übernommen ({env}).",
				default: "Eingebauter Standard.",
				db: "Hier gesetzt.",
				unset: "Nicht gesetzt.",
				clearing:
					"Speichern entfernt den hier gesetzten Wert; dann gilt wieder der Wert aus der Umgebung oder der eingebaute Standard.",
			},
			mail: {
				title: "E-Mail",
				note: "Einladungen, Passwort-Resets und Konto-E-Mails",
				disabled:
					"E-Mail ist nicht eingerichtet. Einladungen, Passwort-Resets und Konto-E-Mails werden erst verschickt, wenn ein Host und eine Absenderadresse gesetzt sind.",
				enabled: "E-Mails werden von {user} über {host} verschickt.",
				dkimOn: "Mit DKIM signiert für {domain}",
				dkimOff: "Nicht mit DKIM signiert",
				host: "SMTP-Host",
				port: "Port (SMTPS)",
				user: "Absenderadresse (SMTP-Login)",
				password: "SMTP-Passwort",
				fromName: "Absendername",
				dkimDomain: "DKIM-Domain",
				dkimSelector: "DKIM-Selektor",
				dkimKey: "Privater DKIM-Schlüssel (PEM)",
				test: "Test-E-Mail senden",
				tested: "Eine Test-E-Mail wurde an {to} geschickt.",
			},
			invitations: {
				title: "Einladungen",
				note: "Ob eine Einladung zu einem Projekt, einem Dataspace oder einer Abteilung per E-Mail verschickt wird",
				sendMail: "Einladungen per E-Mail verschicken",
				on: "An",
				off: "Aus",
				enabled: "Einladungen werden per E-Mail verschickt.",
				disabled:
					"Einladungen werden nicht per E-Mail verschickt. Wer einlädt, erhält stattdessen den Link, um ihn selbst weiterzugeben, und kann eine Einladung nicht erneut senden.",
				noMail: "Der Einladungsversand ist eingeschaltet, aber oben ist keine E-Mail eingerichtet, daher kann keine verschickt werden. Wer einlädt, erhält stattdessen den Link, um ihn selbst weiterzugeben.",
			},
			llm: {
				title: "LLM-Gateway",
				note: "Code-Assistent und Terminologievorschläge",
				disabled:
					"Das LLM-Gateway ist nicht eingerichtet, Code-Assistent und Terminologievorschläge sind deshalb aus. Alle vier Werte sind erforderlich.",
				enabled: "Code-Assistent und Terminologievorschläge nutzen {model}.",
				url: "Basis-URL des Gateways (https://host, ohne Pfad)",
				token: "Token",
				model: "Modell",
				service: "Dienst",
				test: "Verbindung testen",
				tested: "Das Gateway hat in {ms} ms geantwortet.",
			},
			map: {
				title: "Karte",
				note: "Die Karte einer Ortsfrage im Operator — ihre Kacheln über diesen Server, nie direkt aus dem Browser",
				disabled:
					"Keine Karte: Ortsfragen zeigen nur die Adresse und ihre Vorschläge. Tragen Sie einen Kachelserver im eigenen Netz ein, um eine Karte anzuzeigen.",
				enabled: "Ortsfragen zeigen eine Karte mit Kacheln von {host}.",
				publicServers:
					"Das ist ein öffentlicher OpenStreetMap-Kachelserver: Jede Karte, die jemand im Operator öffnet, wird bei der OpenStreetMap Foundation abgerufen, deren Nutzungsrichtlinie intensive Nutzung untersagt. Tragen Sie stattdessen einen Kachelserver im eigenen Netz ein.",
				switch: "Karte",
				on: "An",
				off: "Aus",
				tileUrl: "Kachelserver im eigenen Netz — Basis-URL (http://host:port, ohne Pfad)",
				attribution: "Quellenangabe auf der Karte",
				test: "Verbindung testen",
				tested: "Der Kachelserver hat in {tile} ms geantwortet.",
			},
			processes: {
				title: "Standards für Prozesse",
				note: "Was jeder Prozess für die NOTITIA_*-Variablen bekommt, die sein Dataspace leer lässt",
				noGateway:
					"Prozesse bekommen kein LLM-Gateway: Hier ist keine URL gesetzt, und das LLM-Gateway oben hat keine.",
				noToken:
					"Prozesse bekommen noch kein LLM-Gateway: Tragen Sie ein Token für sie ein. Ohne Token würde jede Anfrage abgelehnt.",
				derived: "Prozesse erreichen das LLM-Gateway unter {url}, dem Gateway oben.",
				set: "Prozesse erreichen das LLM-Gateway unter {url}.",
				llmUrl: "Basis-URL des Gateways für Prozesse (leer: die des LLM-Gateways oben)",
				llmToken: "Gateway-Token für Prozesse — ihr eigenes, nicht das des Servers",
				llmModel: "Modell (leer: Standard der Engine)",
				test: "Als Prozess testen",
				tested: "Das Gateway hat {model} in {ms} ms geantwortet.",
				tableCaption: "Was ein Prozess für jede Variable bekommt",
				variable: "Variable",
				value: "Wert",
				origin: "Quelle",
				source: {
					db: "Kontrollzentrum",
					env: "Umgebung",
					default: "eingebauter Standard",
				},
				missing: {
					unset: "nicht gesetzt",
					no_token: "zurückgehalten: kein Token für Prozesse",
					engine_default: "Standard der Engine",
				},
			},
			location: {
				title: "Ortsdienst",
				note: "Adresssuche und Adresse zur Nadel im Operator — der LiveReader-Ortsdienst, im eigenen Netz",
				disabled:
					"Kein Ortsdienst eingetragen: keine Adresssuche, und eine Nadel auf der Karte liefert nur Koordinaten.",
				enabled: "Adresssuche und Adresse zur Nadel über {host}.",
				everywhere: "Es wird in allen Regionen gesucht, die der Ortsdienst kennt.",
				inRegion: "Gesucht wird in {region}.",
				outdated:
					"Der Ortsdienst meldet sich als {version}, älter als 1.2.0: Adressen werden gefunden, aber ohne Punkte auf der Karte, ohne Alternativen und ohne Adresse zur Nadel, und nicht, solange sein LLM ausfällt. Aktualisieren Sie den Ortsdienst.",
				unknownVersion: "eine Version ohne Namen",
				url: "Ortsdienst — Basis-URL, nur im eigenen Netz",
				timeoutMs: "Zeitlimit in Millisekunden (leer: 10000)",
				region: "Region, in der gesucht wird (leer: alle)",
				test: "Verbindung testen",
				tested: "Ortsdienst {version} hat in {ms} ms geantwortet.",
				testedOutdated:
					"Der Ortsdienst hat in {ms} ms geantwortet, ist aber älter als 1.2.0 ({version}).",
			},
		},
		license: {
			title: "Lizenzschlüssel",
			note: "Wird stündlich beim Lizenzserver geprüft",
			valid: "Lizenziert für {label}.",
			validNote: "Zuletzt bestätigt am {date}.",
			key: "Schlüssel",
			id: "Lizenz-ID",
			label: "Lizenziert für",
			lastCheck: "Zuletzt bestätigt",
			graceEnds: "Karenzzeit endet",
			server: "Lizenzserver",
			features: "Funktionen",
			featureDesigner: "Designer",
			featurePersonalSpaces: "Persönliche Spaces",
			featurePersonalMemberLimit: "Mitgliederlimit persönlicher Spaces",
			featuresDefaults:
				"Der Lizenzserver hat dazu nichts gesagt. Es gelten die Standardwerte; die nächste Prüfung ersetzt sie, falls er sie schickt.",
			on: "An",
			off: "Aus",
			lastError: "Die letzte Prüfung ist fehlgeschlagen ({date})",
			newKey: "Lizenzschlüssel",
			newKeyHelp: "Wird vor dem Speichern beim Lizenzserver geprüft.",
			saveKey: "Prüfen und speichern",
			changeKey: "Schlüssel ändern",
			checkNow: "Jetzt prüfen",
			saved: "Der Lizenzschlüssel ist bestätigt und gespeichert.",
			checked: "Der Lizenzserver hat die Lizenz bestätigt.",
			notice: {
				missing: "Keine Lizenz: Designer und Operator sind geschlossen.",
				missingNote:
					"Geben Sie den Lizenzschlüssel ein, den LiveReader für diesen Server ausgestellt hat.",
				expired:
					"Seit {date} keine bestätigte Lizenz: Designer und Operator sind geschlossen.",
				expiredNote:
					"Der Lizenzserver hat die Lizenz seit 30 Tagen nicht bestätigt. Prüfen Sie jetzt, oder geben Sie einen anderen Schlüssel ein.",
				overdue:
					"Der Lizenzserver hat die Lizenz in letzter Zeit nicht bestätigt. Designer und Operator schließen in {n} Tag, wenn keine Prüfung gelingt. | Der Lizenzserver hat die Lizenz in letzter Zeit nicht bestätigt. Designer und Operator schließen in {n} Tagen, wenn keine Prüfung gelingt.",
				overdueNote: "Designer und Operator schließen am {date}.",
				open: "Lizenz öffnen",
			},
			errors: {
				license_key_unknown:
					"Der Lizenzserver kennt diesen Schlüssel nicht. Prüfen Sie ihn und versuchen Sie es erneut.",
				license_disabled:
					"Laut Lizenzserver ist diese Lizenz deaktiviert. Wenden Sie sich an LiveReader.",
				license_server_unreachable:
					"Der Lizenzserver war nicht erreichbar. Versuchen Sie es später erneut.",
				license_response_invalid: "Die Antwort des Lizenzservers ließ sich nicht lesen.",
				license_key_missing:
					"Es ist kein Lizenzschlüssel gespeichert. Geben Sie zuerst einen ein.",
				invalid_license_key:
					"Ein Lizenzschlüssel ist ein einzelnes Wort, ohne Leerzeichen.",
			},
		},
		errors: {
			lastAdministrator:
				"Danach könnte niemand mehr Benutzer und Systemrollen verwalten. Geben Sie zuerst einer anderen Person eine Rolle, die das erlaubt.",
			lastMemberAdmin:
				"Das ist der letzte Admin. Machen Sie zuerst eine andere Person zum Admin.",
			selfRoleChange:
				"Sie können Ihre eigene Systemrolle nicht ändern. Bitten Sie einen anderen Admin darum.",
			roleLocked:
				"Was diese Rolle gewährt, ist fest. Duplizieren Sie sie, um eine bearbeitbare Rolle anzulegen.",
			roleInUse:
				"Diese Rolle ist noch Benutzern zugewiesen. Weisen Sie ihnen zuerst eine andere zu.",
			roleExists: "Eine Systemrolle mit diesem Namen gibt es schon.",
			missingEntitlement: "Ihre Systemrolle erlaubt das nicht.",
			mailNotConfigured:
				"E-Mail ist nicht eingerichtet: Tragen Sie zuerst einen Host und eine Absenderadresse ein.",
			llmNotConfigured:
				"Das LLM-Gateway ist nicht eingerichtet: Tragen Sie zuerst alle vier Werte ein.",
			mapDisabled:
				"Es gibt keine Karte: Tragen Sie zuerst einen Kachelserver ein und schalten Sie die Karte ein, dann testen Sie sie.",
			locationNotConfigured:
				"Kein Ortsdienst eingetragen: Tragen Sie zuerst seine URL ein, dann testen Sie ihn.",
			processesNotConfigured:
				"Prozesse bekommen noch kein Gateway: Tragen Sie zuerst eine URL und ein Token für sie ein.",
		},
	},
};
